module.exports = __webpack_public_path__ + "27d32dad251a00e5dc4daff64006b19e.pdf";